<template>
  <div class="SitiosListado">
    <md-table v-model="filtro_sitios" md-card md-fixed-header>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Sitios de interés registrados</h1>
        </div>
        <md-field md-clearable class="md-toolbar-section-end">
          <md-input placeholder="Buscar publicación..." v-model="buscar" @input="buscarEnLaTabla" />
        </md-field>
      </md-table-toolbar>
      <md-table-empty-state md-label="No se encontraron sitios de interés" :md-description="``"></md-table-empty-state>
      <md-table-row slot="md-table-row" slot-scope="{ item }" class="md-accent" md-selectable="single">
        <md-table-cell md-label="Descripción">{{ item.desc_sit }} </md-table-cell>
        <md-table-cell md-label="Enlace">{{ item.enlace_sit }}</md-table-cell>
        <md-table-cell md-label="Acciones">
          <md-button class="md-icon-button" @click.native="editarSitio(item)">
            <md-icon>edit</md-icon>
            <md-tooltip md-direction="left">Editar</md-tooltip>
          </md-button>
          <md-button class="md-icon-button" @click.native="eliminar(item)">
            <md-icon>delete</md-icon>
            <md-tooltip md-direction="left">Eliminar</md-tooltip>
          </md-button>
        </md-table-cell>
      </md-table-row>
      <md-button class="md-fab md-mini md-fab-bottom-right" @click.native="form_sitio = true">
        <md-icon>add</md-icon>
      </md-button>
    </md-table>
    <md-dialog :md-active.sync="form_sitio">
      <md-dialog-title>{{sitio.id_sit ? 'Editar' : 'Agregar'}} sitio de interés</md-dialog-title>
      <md-dialog-content>
        <md-field :class="v.desc_sit">
          <label>Descripción</label>
          <md-input v-model="sitio.desc_sit" required />
          <span class="md-error">Por favor llene este campo</span>
        </md-field>
        <md-field :class="v.url_sit">
          <label>URL / Enlace</label>
          <md-input v-model="sitio.url_sit" type="url" required />
          <span class="md-error">Por favor llene este campo</span>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="form_sitio = false">Cerrar</md-button>
        <md-button class="md-raised md-primary" @click.native="guardarSitio()">{{sitio.id_sit ? 'Actualizar' : 'Guardar'}}</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog-confirm :md-active.sync="dialog_eliminar" md-title="Eliminar sitio de interés" :md-content="dialog_titulo" md-confirm-text="Si, borrar" md-cancel-text="Cancelar" @md-cancel="dialog_eliminar = false" @md-confirm="eliminarSitio" />

  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";

const toLower = text => {
  return text.toString().toLowerCase();
};
const buscarNombre = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.nombre).includes(toLower(term)));
  }
  return items;
};

export default {
  name: "SitiosListado",
  props: ["sb"],
  methods: {
    notificacion(a) {
      this.$parent.sb.texto = a;
      this.$parent.sb.mostrar = true;
    },
    buscarEnLaTabla() {
      this.filtro_sitios = buscarNombre(this.sitios, this.buscar);
    },
    obtenerSitios() {
      this.$http.get("sitios").then(
        response => {
          if (response.status === 200 && "sitios" in response.body) {
            this.sitios = response.body.sitios;
            this.filtro_sitios = response.body.sitios;
          } else {
            this.notificacion(response.body.error);
          }
        },
        response => {
          this.notificacion(
            "No se pudo establecer conexión con el servidor para obtener las publicaciones"
          );
        }
      );
    },
    editarSitio(i) {
      this.sitio.id_sit = i.id_sit;
      this.sitio.desc_sit = i.desc_sit;
      this.sitio.url_sit = i.url_sit;
      this.form_sitio = true;
    },
    guardarSitio() {
      if (this.validarCampos()) {
        var url = this.sitio.id_sit ? "sitios/actualizar" : "sitios/guardar";
        this.$http
          .post(url, {
            token: this.$session.get("token"),
            data: this.sitio,
            sitio: this.sitio.id_sit
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                this.notificacion(response.body.msg);
                this.obtenerSitios();
                this.form_sitio = false;
              } else {
                this.notificacion(response.body.error);
              }
            },
            response => {
              this.notificacion(
                "No se pudo establecer conexión con el servidor para " +
                this.sitio.id_sit
                  ? "actualizar"
                  : "guardar" + " el sitio de interés"
              );
            }
          );
      }
    },
    validarCampos() {
      this.v.desc_sit = this.sitio.desc_sit ? false : "md-invalid";
      this.v.url_sit =
        this.sitio.url_sit && this.esURL() ? false : "md-invalid";
      if (this.v.desc_sit || this.v.url_sit) {
        this.notificacion("Por favor llene los campos indicados");
        return false;
      } else {
        return true;
      }
    },
    esURL() {
      var re = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
      return re.test(this.sitio.url_sit);
    },
    eliminar(p) {
      this.dialog_titulo =
        "¿Está seguro desea eliminar el sito de interés " + p.desc_sit + "?";
      this.sitio.id_sit = p.id_sit;
      this.dialog_eliminar = true;
    },
    eliminarSitio() {
      this.dialog_eliminar = false;
      this.$http
        .post("sitios/eliminar", {
          token: this.$session.get("token"),
          sitio: this.sitio.id_sit
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              this.obtenerSitios();
              this.notificacion(response.body.msg);
            } else {
              this.notificacion(response.body.error);
            }
          },
          response => {
            this.notificacion(
              "No se pudo establecer conexión con el servidor para eliminar el sitio de interés"
            );
          }
        );
    }
  },
  watch: {
    form_sitio(v) {
      if (!v) {
        this.sitio.id_sit = null;
        this.sitio.desc_sit = null;
        this.v.desc_sit = null;
        this.sitio.url_sit = null;
        this.v.url_sit = null;
      }
    }
  },
  data() {
    return {
      buscar: null,
      publicaciones: [],
      filtro_sitios: [],
      dialog_eliminar: false,
      dialog_titulo: "",
      form_sitio: false,
      sitio: {
        id_sit: null,
        desc_sit: null,
        url_sit: null
      },
      v: {
        id_sit: null,
        desc_sit: null,
        url_sit: null
      }
    };
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerSitios();
  }
};
</script>